import { Expression } from './Expression.js';
export class ConstExpression extends Expression {
    constructor(value) {
        super();
        this.value = value;
    }
    evaluate(visitor, localVariables) {
        return this.value;
    }
}
//# sourceMappingURL=ConstExpression.js.map